// the css is injected automatically
require('!style-loader!css-loader!postcss-loader!stylus-loader!./gdprtext.styl');

// this helps us remove everything exepct whats inside the body node
var strip = require("striphtml");
var getData = require('../../scripts/getdata')(MBGF.mbfa_apibase);
var validation = require('validation')(getData).gdprtext;
var parsing = require('parsing').gdprtext;
var moduleHelper = require('../../scripts/module-helper');
var localization = require('../../scripts/localization');

function parse(text, next) {

    var customGDPRText = typeof MBGF != "undefined" && MBGF.GDPRText;
    var useCustomGDPRText = customGDPRText !== '';
 
    strip(require('raw!./gdprtext.html'), function(outputHtml) {

        // Pick out the correct html based on the language
        var languageRe = /<!-- language: (\w\w) -->((.|\r|\n)*?)<!--\/language: (\w\w) -->/g;

        var part = languageRe.exec(outputHtml);
        while (part) {
            if (part[1] !== MBGF.language.toUpperCase()) {
                outputHtml = outputHtml.replace(part[0], '');
            }
            part = languageRe.exec(outputHtml);
        }

        var match = parsing.parse(text);
        if (match) {
            if (useCustomGDPRText) {
                outputHtml = outputHtml.replace(/\{\{customGDPRText\}\}/g, '<div class="gdprtext-custom-content-header">' + customGDPRText + '</div>');
                text = text.replace(match[0], outputHtml);
            } else {
                outputHtml = outputHtml.replace(/\{\{customGDPRText\}\}/g, '');
                text = text.replace(match[0], outputHtml);
            }
        }
        next(text);
    });

};

function init(formRoot, meta, next) {

    var context = formRoot.querySelector('[data-module="gdprtext"]');

    if (context) {
 
        var content = context.querySelector('[data-gdprtext-content="true"]');
        var button = context.querySelector('a[data-activator="true"]');

        context.toggleBox = function(e) {


            if (e) {
                e.preventDefault();
            }

            content.classList.toggle('gdprtext-opened');

            if (content.classList.contains('gdprtext-opened')) {
                button.innerHTML = button.getAttribute('data-text-opened'); 
            } else {
                button.innerHTML = button.getAttribute('data-text-closed'); 
            }

        }

        if (button) {
            button.addEventListener('click', context.toggleBox);
        } else {
            content.classList.add('gdprtext-opened');
        }

    }

    next(formRoot);

}

function get(context) {
    return '';
}

function reset(context) {
}

module.exports = {
    parse: parse,
    init: init,
    get: get,
    reset: reset,
};



// WEBPACK FOOTER //
// ./js-src/markdown-editor/modules/gdprtext/gdprtext.js